<template>
  <div class="base-dashboard">
    <div
      v-if="userIsAdmin"
      class="app-align-items-center my-4"
    >
      <v-spacer />
      <BaseButton
        v-if="!enabledEditSchema"
        :has-icon="true"
        button-class="ma-0"
        @click="openEditSchema()"
      >
        <v-icon>settings</v-icon>
      </BaseButton>
      <template v-else>
        <BaseButton
          type="text"
          @click="discardSchemaChanges()"
        >
          Descartar
        </BaseButton>
        <BaseButton
          @click="saveSchemaChanges()"
        >
          Salvar
        </BaseButton>
      </template>
    </div>
    <template v-if="(getDashboardByRole && parseContainer.length) || enabledEditSchema">
      <template v-for="container,key in parseContainer">
        <BaseContainer
          :key="`container-${key}`"
          :active-spacer="true"
          base-container-classes="pb-8"
        >
          <template v-slot:header-title>
            {{ !container.title && enabledEditSchema ? 'Adicionar título' : container.title }}
            <BaseButton
              v-if="enabledEditSchema"
              :has-icon="true"
              button-class="ma-0"
              @click="openBaseModal('title', container, key)"
            >
              <v-icon>edit</v-icon>
            </BaseButton>
          </template>
          <template v-slot:header-title-description>
            {{ !container.description && enabledEditSchema ? 'Adicionar subtítulo' : container.description }}
          </template>
          <template v-slot:header-actions>
            <BaseButton
              v-for="button, btnIndex in container.actions"
              :key="btnIndex"
              type="text"
              color="blueff"
              class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0 text-decoration-underline text-uppercase"
              button-class="app-font-regular"
              @click="onClick(button.action)"
            >
              {{ button.title }}
            </BaseButton>
            <BaseButton
              v-if="enabledEditSchema"
              :has-icon="true"
              button-class="ma-0"
              @click="openBaseModal('delete-section', container, key)"
            >
              <v-icon>delete</v-icon>
            </BaseButton>
          </template>
          <v-divider class="mb-8" />
          <div
            class="app-align-items-center"
          >
            <div
              v-if="container.filter_date && !isObjectEmpty(container.filter_date)"
              class="app-align-items-center mb-8"
            >
              <div
                v-if="container.filter_date.custom_date"
                id="id-selected-filter"
              >
                <v-menu
                  :ref="`refMenu-${key}`"
                  :close-on-content-click="false"
                  :min-width="288"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      class="font-weight-bold mx-1"
                      label
                      text-color="primary"
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        left
                        small
                      >
                        calendar_today
                      </v-icon>
                      &nbsp; {{ selectedDateLabel }}
                      <v-icon
                        left
                        class="mx-1"
                      >
                        arrow_drop_down
                      </v-icon>
                    </v-chip>
                  </template>
                  <v-card>
                    <div class="pa-4">
                      <div class="app-align-items-center">
                        <BaseDatePicker
                          name-placeholder="Data Inicial"
                          :date-value="tempFilterDate.start_date"
                          :max="tempFilterDate.end_date"
                          :max-width="118"
                          locale="pt-br"
                          time-zone="UTC"
                          @on-input-date-picker="(value) => { tempFilterDate.start_date = value }"
                        />
                        <v-spacer />
                        <BaseDatePicker
                          name-placeholder="Data Final"
                          :date-value="tempFilterDate.end_date"
                          :max-width="118"
                          locale="pt-br"
                          time-zone="UTC"
                          @on-input-date-picker="(value) => { tempFilterDate.start_date = value }"
                        />
                      </div>
                      <BaseButton
                        :is-disabled="!tempFilterDate.start_date || !tempFilterDate.end_date"
                        @click="sendDates(key)"
                      >
                        Aplicar
                      </BaseButton>
                    </div>
                  </v-card>
                </v-menu>
              </div>
              <div v-else>
                <v-chip
                  class="font-weight-bold mx-1"
                  label
                  text-color="primary"
                  color="secondary"
                >
                  <v-icon
                    left
                    small
                  >
                    calendar_today
                  </v-icon>
                  &nbsp; {{ container.filter_date.label }}
                </v-chip>
              </div>
              <v-tooltip
                v-if="container.filter_date.info"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span>{{ container.filter_date.info }}</span>
              </v-tooltip>
            </div>
            <template v-if="enabledEditSchema">
              <template v-if="isObjectEmpty(container.filter_date)">
                <v-icon
                  left
                  small
                  class="mr-2 mb-8"
                >
                  calendar_today
                </v-icon>
                <span class="mb-8 mr-2">Filtro de data</span>
              </template>
              <BaseButton
                :has-icon="true"
                button-class="ma-0 mb-8"
                @click="openBaseModal('filter', container, key)"
              >
                <v-icon>edit</v-icon>
              </BaseButton>
            </template>
          </div>
          <draggable
            v-model="container.charts"
            :disabled="!enabledEditSchema"
            class="row"
            @start="isDragActive = true"
            @end="isDragActive = false"
          >
            <v-col
              v-for="chart, index in container.charts"
              :key="index"
              cols="12"
              :md="chart.layout_cols || 6"
              class="pa-0"
            >
              <v-hover v-slot="{ hover }">
                <div
                  class="pa-2 mr-3 mb-4"
                  :class="{ 'elevation-6' : isDragActive, 'px-4': !enabledEditSchema }"
                  :style="{
                    'height' : (((chart.layout_rows ? chart.layout_rows : 3) * 126) + (enabledEditSchema ? 56 : 46)) + 'px',
                    'background-color': isDarkTheme ? '#FFFFFF4F' : '#FFF',
                    'cursor' : chart.link ? 'pointer' : 'default',
                  }"
                  @click="onChartClick(chart.link)"
                >
                  <h3
                    class="app-align-items-center mb-2"
                  >
                    <v-icon
                      v-if="enabledEditSchema"
                      class="mr-4"
                    >
                      mdi-cursor-move
                    </v-icon>
                    {{ chart.title }}
                    <v-spacer />
                    <v-icon
                      v-if="!enabledEditSchema && (hover && chart.link)"
                    >
                      mdi-export
                    </v-icon>
                    <BaseMenuOptions
                      v-if="enabledEditSchema"
                      :menu-itens="menuItens"
                      :item-data="{ context: 'chart', data: container, index: key, chartIndex: index }"
                      align-menu="left"
                    />
                  </h3>
                  <iframe
                    v-if="showEmbed && getIframeUrl(chart, container)"
                    width="100%"
                    seamless
                    :height="(chart.layout_rows ? chart.layout_rows : 3) * 126"
                    frameBorder="0"
                    scrolling="yes"
                    :src="getIframeUrl(chart, container)"
                  />
                </div>
              </v-hover>
            </v-col>
            <v-col
              v-if="enabledEditSchema"
              cols="3"
              class="app-align-items-center mb-4"
              style="height: 182px; cursor: pointer;"
              :style="{'background-color': isDarkTheme ? '#FFFFFF4F' : '#FFF'}"
              @click="openBaseModal('add-chart', container, key)"
            >
              <div
                class="text-center"
                style="margin: 0 auto;"
              >
                <v-icon>mdi-plus</v-icon>
                <p class="font-weight-bold">
                  Adicionar novo gráfico
                </p>
              </div>
            </v-col>
          </draggable>
        </BaseContainer>
      </template>
    </template>
    <div
      v-else
      class="my-12"
    >
      <span v-if="userIsAdmin">Não há dados para exibir. Clique na engrenagem para criar ou editar a seção.</span>
      <span v-else>Não há dados para exibir. Utilize os filtros acima para buscar novos dados.</span>
    </div>
    <template v-if="enabledEditSchema">
      <v-divider class="my-8" />
      <v-col
        cols="12"
        class="app-align-items-center mb-4"
        style="height: 182px; cursor: pointer;"
        :style="{'background-color': isDarkTheme ? '#FFFFFF4F' : '#FFF'}"
        @click="openBaseModal('add-section')"
      >
        <div
          class="text-center"
          style="margin: 0 auto;"
        >
          <v-icon>mdi-plus</v-icon>
          <p class="font-weight-bold">
            Adicionar nova seção
          </p>
          <p>Configure título, descrição, filtro e adicione os gráficos da seção.</p>
        </div>
      </v-col>
    </template>
    <v-dialog
      v-model="baseModal.active"
      max-width="560"
      persistent
    >
      <BaseModal
        :show-indeterminate-progress="baseModal.showIndeterminateProgress"
        :top-slot-content-title="baseModal.topSlotContentTitle"
        :remove-button-close="baseModal.removeButtonClose"
        :middle-slot-content-text-highlight="baseModal.middleSlotContentTextHighlight"
        :middle-slot-content-text="baseModal.middleSlotContentText"
        :bottom-buttons-align="baseModal.bottomButtonsAlign"
        :bottom-slot-content-button-cancel-label="baseModal.bottomSlotContentButtonCancelLabel"
        :bottom-slot-content-button-confirm-label="baseModal.bottomSlotContentButtonConfirmLabel"
        :remove-button-cancel="baseModal.removeButtonCancel"
        :remove-button-confirm="baseModal.removeButtonConfirm"
        :custom-enable-bottom-button-confirm-label="baseModal.valid"
        @on-cancel="closeBaseModal()"
        @on-confirm="saveBaseModal()"
      >
        <template
          v-slot:inject-form
        >
          <v-form
            ref="formBaseModal"
            v-model="baseModal.valid"
          >
            <template v-if="modalContext === 'title'">
              <BaseInput
                v-model="modelBaseModal.title"
                label="Título"
                hint="Preencha com o título da seção"
                persistent-hint
                class="my-4"
              />
              <BaseInput
                v-model="modelBaseModal.description"
                label="Subtítulo"
                hint="Preencha com o subtítulo da seção"
                persistent-hint
                class="my-4"
              />
            </template>
            <template v-else-if="modalContext === 'filter'">
              <v-radio-group
                v-model="modelFilterRadio"
                :rules="[isValid]"
                hide-details
                class="my-3"
              >
                <v-radio
                  v-for="option, i in optionsFilterRadio"
                  :key="i"
                  :label="option.text"
                  :value="option.value"
                />
              </v-radio-group>

              <BaseInput
                v-if="modelFilterRadio === 'fixed'"
                v-model="modelBaseModal.filter_date.label"
                label="Título"
                hint="Adicione a descrição que aparecerá no filtro de data"
                persistent-hint
                :rules="[isValid]"
                class="my-4"
              />
              <BaseInput
                v-if="modelFilterRadio === 'custom-date' || modelFilterRadio === 'fixed'"
                v-model="modelBaseModal.filter_date.info"
                label="Informação"
                hint="Adicione uma descrição que aparecerá no ícone 'i' ao lado da data"
                persistent-hint
                class="my-4"
              />
            </template>
            <template v-else-if="modalContext === 'chart' || modalContext === 'add-chart'">
              <BaseInput
                v-model="modelChart.title"
                label="Título"
                hint="Preencha o título do gráfico"
                persistent-hint
                class="my-4"
              />
              <BaseInput
                v-model="modelChart.url"
                label="URL"
                hint="Preencha com a URL do gráfico do Superset"
                persistent-hint
                :rules="[isValid]"
                class="my-4"
              />
              <v-select
                v-model="modelChart.layout_cols"
                :items="optionsLayoutCols"
                item-text="text"
                item-value="value"
                label="Colunas"
                hint="Selecione a quantidade de colunas"
                persistent-hint
                :rules="[isValid]"
                class="mr-2"
              >
                <template v-slot:item="{item}">
                  <img
                    :src="require(`@/assets/${item.icon}`)"
                    width="35px"
                    class="mr-2"
                  >
                  {{ item.text }}
                </template>
              </v-select>
              <v-text-field
                v-model="modelChart.layout_rows"
                label="Linhas"
                hint="Preencha com a quantidade de linhas do gráfico. Cada linha tem 126px."
                persistent-hint
                :rules="[isValid]"
                type="number"
                class="my-4"
              />
              <BaseInput
                v-model="modelChart.link"
                label="Link"
                hint="Preencha com o link para direcionar para outra página. Ex: '/#/trades?status.name=Baixado'"
                persistent-hint
                class="my-4"
              />
            </template>
          </v-form>
        </template>
      </BaseModal>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"
import BaseContainer from './BaseContainer'
import BaseDatePicker from './BaseDatePicker'
import BaseModal from './BaseModal'
import BaseMenuOptions from './BaseMenuOptions'
import permissions from '../mixins/permissions'
import draggable from 'vuedraggable'

export default {
  components: { BaseContainer, BaseDatePicker, BaseModal, BaseMenuOptions, draggable },
  mixins: [ permissions ],
  props: {
    selectedRole: {
      type: String,
      required: true,
      default: null
    },
    selectedProgram: {
      type: Object,
      required: true,
      default: null
    },
    selectedConfigurationId: {
      type: String,
      required: true,
      default: null
    },
    selectedOrganization: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: () => ({
    dashboardUrlList: {},
    showEmbed: false,
    filterDateMenu: false,
    filterDate: {
      start_date: '',
      end_date: ''
    },
    applyDate: false,
    enabledEditSchema: false,
    parseContainer: [],
    copyContainer: [],
    copyEditableBlock: {},
    isDragActive: false,
    modalContext: null,
    baseModal: {
      active: false,
      valid: false,
      showIndeterminateProgress: false,
      topSlotContentTitle: "Título",
      removeButtonClose: false,
      middleSlotContentTextHighlight: "",
      middleSlotContentText: "",
      bottomButtonsAlign: "right",
      bottomSlotContentButtonCancelLabel: "Cancelar",
      bottomSlotContentButtonConfirmLabel: "Confirmar",
      removeButtonCancel: false,
      removeButtonConfirm: false,
    },
    modelChart: {},
    modelBaseModal: {},
    modelFilterRadio: 'hide-date',
    optionsFilterRadio: [
      { text: 'Sem filtro de data', value: 'hide-date' },
      { text: 'Data personalizável', value: 'custom-date' },
      { text: 'Texto de data fixa', value: 'fixed' }
    ],
    optionsLayoutCols: [
      { text: 'Layout 1 coluna', value: 12, icon: '1-col.png' },
      { text: 'Layout 2 colunas', value: 6, icon: '2-col.png' },
      { text: 'Layout 3 colunas', value: 4, icon: '3-col.png' },
      { text: 'Layout 4 colunas', value: 3, icon: '4-col.png' },
      { text: 'Layout 5 colunas', value: 2, icon: '5-col.png' }
    ],
    tempFilterDate: {
      start_date: '',
      end_date: ''
    },
    applyDate: false
  }),
  computed: {
    ...mapState({
      ticket: state => state.ticket
    }),
    getDashboardByRole() {
      let key = this.selectedConfigurationId+this.selectedRole
      return this.dashboardUrlList[key] ? this.dashboardUrlList[key] : null
    },
    selectedDateLabel() {
      if (!this.applyDate) {
        return 'Últimos 30 dias'
      }
      return `Período: ${this.$options.filters.getDate(this.filterDate.start_date)} - ${this.$options.filters.getDate(this.filterDate.end_date)}`
    },
    menuItens() {
      return [
        {
          text: "Editar",
          execute: (item) => {
            const {context, data, index, chartIndex } = item
            this.openBaseModal(context, data, index, chartIndex)
          },
          disableButton(item) { return false },
          hideButton(item){ return false }
        },
        {
          text: "Excluir",
          execute: (item) => {
            const { data, index, chartIndex } = item
            this.openBaseModal('delete-chart', data, index, chartIndex)
          },
          disableButton(item) { return false },
          hideButton(item){ return false }
        }
      ]
    }
  },
  watch: {
    getDashboardByRole: {
      async handler(value) {
        if (value) {
          let payload = this.selectedProgram.initiator === 'TODOS' ? { "all_programs": true } : { program_id: this.selectedProgram.initiator }

          let orgTaxNumber = this.selectedOrganization && this.selectedOrganization.tax_number || null
          if(orgTaxNumber){
            payload.organization_tax_number = orgTaxNumber
          }

          this.setContainerValue(this.parseChartList(this.getDashboardByRole))
          if(this.parseContainer){
            await this.apiGetTicket(payload)
          }
          this.showEmbed = true
        } else {
          this.showEmbed = false
        }
      },
      deep: true
    },
    selectedProgram: {
      handler() {
        this.getProgramDashboardUrl()
      },
      deep: true
    },
    selectedConfigurationId() {
      this.getProgramDashboardUrl()
    },
    selectedOrganization: {
      handler() {
        this.getProgramDashboardUrl()
      },
      deep: true
    }
  },
  created() {
    this.getProgramDashboardUrl()
    this.filterDate = {
      start_date: this.toLocalDate(this.minusDays(new Date(), 30)).toISOString().substr(0, 10),
      end_date: this.toLocalDate(new Date()).toISOString().substr(0, 10)
    }
    this.tempFilterDate = Object.assign({}, this.filterDate)
  },
  methods: {
    ...mapActions(["apiGetTicket", "apiUpdateMePrograms", "apiGetMePrograms", "apiUpdateProgramConfigurations", "apiGetAllPrograms"]),
    ...mapMutations(['setPermissionErrorMessage']),
    getIframeUrl(chart, container) {
      let heightChart = 126 * (chart.layout_rows ? chart.layout_rows : 3)
      let splitUrl = chart.url.split('?')
      let dateCharts = `start_date=${this.filterDate.start_date}&end_date=${this.filterDate.end_date}`
      let urlTicket = `ticket=${this.ticket}&height=${heightChart}${container.filter_date && container.filter_date.custom_date ? `&${dateCharts}` : ''}`

      let paramToUrlChart = splitUrl[1] ? `?${splitUrl[1]}` + `&${urlTicket}` : `?${urlTicket}`
      let url = splitUrl[0] ? splitUrl[0] + paramToUrlChart : null
      return url
    },
    getProgramDashboardUrl() {
      this.dashboardUrlList = []
      if (this.selectedProgram && this.selectedProgram.configuration) {
        let selectedKey = this.selectedConfigurationId+this.selectedRole

        Object.keys(this.selectedProgram.configuration).forEach(key => {
          if (key.includes('dashboard_url')){
            let configDashURL = this.selectedProgram.configuration[key]
            this.dashboardUrlList = Object.assign({}, {
              ...this.dashboardUrlList,
              [key]: configDashURL
            })
          }
        })

        if(this.selectedProgram.configuration[selectedKey]) {
          this.setContainerValue(this.parseChartList(this.selectedProgram.configuration[selectedKey]))
          this.setCopyContainer({ value: this.selectedProgram.configuration[selectedKey]})
        } else {
          this.setContainerValue([])
          this.setCopyContainer({ value: []})
        }
      } else if (this.selectedProgram && this.selectedProgram.value && this.selectedProgram.initiator === "TODOS") {
        this.setCopyContainer(this.parseChartList(this.selectedProgram))
        this.dashboardUrlList = Object.assign({}, {
          [this.selectedRole]: this.selectedProgram.value
        })
      }
    },
    parseChartList(value) {
      let parseList = typeof value === 'string' && value.startsWith('[') ? JSON.parse(value) : value
      let convertedList = null
      if(parseList[0] && parseList[0].url){
        convertedList = [
          {
            "title":"",
            "description":"",
            "filter_date": {},
            "charts": parseList
          }
        ]
      } else if(typeof parseList === 'string'){
        convertedList = [
          {
            "title":"",
            "description":"",
            "filter_date": {},
            "charts": [
              {
                url: parseList,
                layout_cols: 12,
                layout_rows: 5
              }
            ]
          }
        ]
      } else {
        convertedList = parseList
      }
      return convertedList
    },
    onClick(value) {
      console.log('click: ', value)
    },
    onChartClick(link) {
      if (link && !this.enabledEditSchema) {
        let url = window.location.hostname
        let initiator = this.selectedProgram.initiator.toLowerCase()
        let pathUrl = `https://${initiator}.${url}${link}`

        if (url === 'localhost') {
          window.open(link, '_blank');
        } else {
          window.open(pathUrl, '_blank');
        }
      }
    },
    sendDates(key) {
      this.filterDate = Object.assign({}, this.tempFilterDate)
      this.applyDate = true
      this.closeMenu(key)
    },
    closeMenu(key) {
      this.$refs[`refMenu-${key}`][0].isActive = false
    },
    clearModels(){
      this.modelBaseModal = { filter_date: {}}
      this.modelChart = {}
      this.modelFilterRadio = 'hide-date'
    },
    setContainerValue(value, index = null, key = null, chartIndex = null){
      this.$nextTick(() => {
        if(index != null){
          if(key != null){
            this.$set(this.parseContainer[index], key, value)
          } else if(chartIndex != null) {
            Object.assign(this.parseContainer[index].charts[chartIndex], value)
          } else {
            this.parseContainer[index] = Object.assign({}, value)
          }
        } else {
          this.parseContainer = value
        }
      })
    },
    setModelValue(key, value){
      this.$set(this.modelBaseModal, key, value)
    },
    setCopyContainer(value){
      this.copyContainer = Object.assign({}, value)
    },
    openEditSchema() {
      this.enabledEditSchema = !this.enabledEditSchema
      this.$emit('isEditingDashboard', true)
    },
    discardSchemaChanges() {
      let valueToSet = this.copyContainer.value ? this.parseChartList(this.copyContainer.value) : []
      this.$nextTick(() => {
        this.enabledEditSchema = false
        this.clearModels()
        this.setContainerValue(valueToSet)
        this.$emit('isEditingDashboard', false)
      })
    },
    async saveSchemaChanges() {
      if(this.selectedProgram.initiator === 'TODOS'){
        let payload = Object.assign({}, {
          ...this.copyContainer,
          scope: this.copyContainer.scope || "registry",
          type: this.copyContainer.type || "dashboard",
          value: JSON.stringify(this.parseContainer)
        })
        delete payload.initiator
        delete payload.id

        try {
          await this.apiUpdateMePrograms({
            scope: 'registry',
            data: payload
          })
          await this.apiGetMePrograms({ scope: 'registry' })
        } catch (error) {
          this.setPermissionErrorMessage({
            active: true,
            msg: 'Erro ao salvar dashboard. Tente novamente.'
          })
        }
      } else {
        let payload = {
          [`config.${this.selectedConfigurationId}${this.selectedRole}`]: JSON.stringify(this.parseContainer)
        }
        try {
          await this.apiUpdateProgramConfigurations({ programId: this.selectedProgram.id, data: payload })
          await this.apiGetAllPrograms()
        } catch (error) {
          this.setPermissionErrorMessage({
            active: true,
            msg: 'Erro ao salvar dashboard. Tente novamente.'
          })
        }
      }
      this.enabledEditSchema = false
      this.$emit('isEditingDashboard', false)
    },
    closeBaseModal() {
      this.$nextTick(() => {
        this.baseModal.active = false
        this.clearModels()
        this.setContainerValue(this.copyEditableBlock.value, this.copyEditableBlock.index)
      })
    },
    openBaseModal(context, value, index, chartIndex = null){
      this.modalContext = context
      if(value){
        this.copyEditableBlock = Object.assign({}, {
          value: {
            ...value,
            filter_date: { ...value.filter_date }
          },
          index,
          chartIndex
        })
      }
      switch (context) {
        case "title":
          this.setModelValue('title', this.parseContainer[index].title)
          this.setModelValue('description', this.parseContainer[index].description)
          Object.assign(this.baseModal, {
            active: true,
            topSlotContentTitle: "Editar título e descrição",
            middleSlotContentText: ""
          })
        break;
        case "filter":
          if(this.copyEditableBlock.value && this.copyEditableBlock.value.filter_date && !this.isObjectEmpty(this.copyEditableBlock.value.filter_date)){
            if(this.copyEditableBlock.value.filter_date.label){
              this.modelFilterRadio = 'fixed'
            } else if (this.copyEditableBlock.value.filter_date.custom_date){
              this.modelFilterRadio = 'custom-date'
            }
          } else {
            this.modelFilterRadio = 'hide-date'
          }
          this.setModelValue('filter_date', this.parseContainer[index].filter_date)
          Object.assign(this.baseModal, {
            active: true,
            topSlotContentTitle: "Editar filtro de data",
            middleSlotContentText: ""
          })
        break;
        case "chart":
          Object.keys(this.parseContainer[index].charts[chartIndex]).forEach(key => {
            this.$set(this.modelChart, key, this.parseContainer[index].charts[chartIndex][key])
          })
          Object.assign(this.baseModal, {
            active: true,
            topSlotContentTitle: "Editar gráfico",
            middleSlotContentText: ""
          })
        break;
        case "add-chart":
          Object.assign(this.baseModal, {
            active: true,
            topSlotContentTitle: "Adicionar gráfico",
            middleSlotContentText: ""
          })
        break;
        case 'delete-chart':
          const selectedChart = this.parseContainer[index].charts[chartIndex]
          Object.assign(this.baseModal, {
            active: true,
            topSlotContentTitle: "Excluir gráfico",
            middleSlotContentText: `<p class="my-4">Tem certeza que deseja excluir o gráfico <b>${selectedChart.title}</b>?</p>`
          })
        break;
        case 'add-section':
          this.parseContainer.push({
            "title": "Adicionar título",
            "description": "Adicionar subtítulo",
            "filter_date": {
            },
            "charts": []
          })
        break;
        case 'delete-section':
          const selectedSection = this.parseContainer[index]
          Object.assign(this.baseModal, {
            active: true,
            topSlotContentTitle: "Excluir seção",
            middleSlotContentText: `<p class="my-4">Tem certeza que deseja excluir a seção <b>${selectedSection.title}</b>?</p>`
          })
        break;
        default:
        break;
      }
    },
    saveBaseModal() {
      switch (this.modalContext) {
        case 'title':
          this.setContainerValue(this.modelBaseModal.title, this.copyEditableBlock.index,'title')
          this.setContainerValue(this.modelBaseModal.description, this.copyEditableBlock.index, 'description')
        break;
        case 'filter':
          const modelList = {
            'hide-date': () => {
              this.setContainerValue({}, this.copyEditableBlock.index, 'filter_date')
            },
            'custom-date': () => {
              delete this.parseContainer[this.copyEditableBlock.index].filter_date.label
              this.setContainerValue({
                ...this.modelBaseModal.filter_date,
                'custom_date': true
              }, this.copyEditableBlock.index, 'filter_date')
            },
            'fixed': () => {
              this.setContainerValue({
                ...this.modelBaseModal.filter_date,
                'custom_date': false
              }, this.copyEditableBlock.index, 'filter_date')
            }
          }
          modelList[this.modelFilterRadio]()
        break;
        case 'chart':
          this.setContainerValue(this.modelChart, this.copyEditableBlock.index, null, this.copyEditableBlock.chartIndex)
        break;
        case 'add-chart':
          this.parseContainer[this.copyEditableBlock.index].charts.push(this.modelChart)
        break;
        case 'delete-chart':
          this.parseContainer[this.copyEditableBlock.index].charts.splice(this.copyEditableBlock.chartIndex, 1)
        break;
        case 'delete-section':
          this.parseContainer.splice(this.copyEditableBlock.index, 1)
        break;
        default:
        break;
      }
      this.baseModal.active = false
      this.clearModels()
    },
    isObjectEmpty(value){
      let objectValue = value
      return JSON.stringify(objectValue) == '{}'
    }
  }
}
</script>
